import { AfterViewInit, Component, OnInit, Inject } from '@angular/core';
import { AuthService } from 'src/app/core/auth/auth.service';
import { menuItem } from 'src/app/core/interfaces/menuItem.model';
import { Account, User } from 'src/app/core/interfaces/user.model';
import { HelperService } from 'src/app/core/services/helper.service';
import { NavbarService } from 'src/app/core/services/navbar.service';
import { MODALES } from 'src/app/core/Utils/global';
import { AccountService } from '../../core/services/account.service';
import { NavigationEnd, Router } from '@angular/router';
import { timeout } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.css']
})
export class NavbarComponent implements OnInit, AfterViewInit {
  isBrowser: boolean;
  menuLateral = false;
  menuItems: menuItem[];
  menuItemsFo: menuItem[]
  menuItemsLoading = false;

  isLogged = false;
  hasSuscription = false;
  isFelixOliver = false;

  modalLogin: any;
  modalRegister: any;

  usuario: any;

  appLink = "https://play.google.com/store/apps/details?id=com.mascinemateca.app"

  buscarTemp = "";

  constructor(private navbarService: NavbarService, private helperService: HelperService,
    private authService: AuthService, private accountService: AccountService, private router: Router, @Inject(PLATFORM_ID) platformId) {
    this.isBrowser = isPlatformBrowser(platformId);
  }

  async ngOnInit() {

    this.routeCheck();
    this.cargarMenus();

    this.navbarService.$menuActive.subscribe(estado => this.menuLateral = estado);

    this.helperService.$abrirModal.subscribe(modal => {
      this.abrirModal(modal)
    })

    // Escuchar cuando el usuario se loguea o desloguea
    this.authService.logged$.subscribe(async estado => {
      this.isLogged = estado;
      // Obtener el email del usuario logueado
      if (estado) {
        await this.cargarUsuario()
      }
      else {
        this.usuario = null;
      }
    });

    // Escuchar cuando el usuario se suscribe 
    this.accountService.suscripto$.subscribe(async estado => {
      if (estado) {
        this.usuario = await this.accountService.getAccountNoEvent();
      }
      this.hasSuscription = estado;
    })
  }

  ngAfterViewInit(): void {
    if (this.isBrowser) {
      this.modalLogin = $('#modalLogin');
      this.modalRegister = $('#modalRegister');
    }
  }

  async cargarUsuario() {
    this.usuario = await this.accountService.getAccount();
  }

  async cargarMenus() {
    this.menuItemsLoading = true;

    await this.navbarService.getMenu().then((items) => {
      this.menuItems = items;
    });

    await this.navbarService.getMenuFO().then((items) => {
      this.menuItemsFo = items;
    });
    this.menuItemsLoading = false;
  }

  menu_alternar() {
    if (this.menuLateral)
      this.navbarService.cerrarMenu()
    else
      this.navbarService.abrirMenu()
  }

  timer = environment.search_debounce;
  timeOut = null;

  buscar(event: any) {
    if (this.timeOut) clearTimeout(this.timeOut);

    this.timeOut = setTimeout(() => {
      let texto = event.value?.trim();

      this.buscarTemp = texto;
      if (texto.length > 2) {
        this.router.navigate(['/search', texto]);
      }

    }, this.timer);
  }

  buscarYa(event: any) {
    if (this.timeOut) clearTimeout(this.timeOut);

    let texto = event.value?.trim();

    this.buscarTemp = texto;
    if (texto.length > 2) {
      this.router.navigate(['/search', texto]);
    }
  }


  /**
   * Abre modal declarado, se pasa por parámetro el identificador del DOM o el objeto modal
   * @param modal Strings
   */
  abrirModal(modal: MODALES) {
    if (modal) {
      this.cerrarModales();

      let nombreModal = "modal" + this.helperService.toCamelCase(" " + modal);
      if (modal) this[nombreModal].modal('show');
    }
  }

  cerrarModales() {
    if (this.modalLogin) this.modalLogin.modal('hide');
    if (this.modalRegister) this.modalRegister.modal('hide');
  }

  validarYCerrar(estado) {
    if (estado) this.cerrarModales();
  }

  cerrarSesion() {
    this.authService.logout();
  }

  descargarApp() {
    window.open(this.appLink, "_blank");
  }

  routeCheck() {
    //primera ves lo pido sin evento porque no hay navigation.
    let currentRoute = this.router.url;

    //me suscribo al evento para escuchar el cambio de ruta.
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        currentRoute = event.urlAfterRedirects;
        this.isFelixOliver = currentRoute.includes('felix-oliver') ? true : false;
      }
    });
    this.isFelixOliver = currentRoute.includes('felix-oliver') ? true : false;
  }
}
